(function () {
  document.addEventListener(
    "click",
    (e) => {
      // Nur wenn im Produkt-Media-Bereich geklickt wurde
      const mediaArea = e.target.closest(
        "modal-opener, .product__media, .product__media-wrapper, .product__media-gallery, media-gallery, product-media-gallery"
      );
      if (!mediaArea) return;

      // Nicht auf Controls/Links reagieren
      if (e.target.closest("a, button, summary, details, .thumbnail, .slider-buttons, .slider-counter")) return;

      const thumbs = Array.from(
        document.querySelectorAll(".thumbnail-list .thumbnail, .product__media-sublist .thumbnail, .thumbnail")
      );
      if (thumbs.length < 2) return;

      let currentIndex = thumbs.findIndex((t) => t.getAttribute("aria-current") === "true");
      if (currentIndex === -1) currentIndex = 0;

      const nextIndex = (currentIndex + 1) % thumbs.length;

      // Modal verhindern, damit der Klick fürs Wechseln genutzt wird
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();

      thumbs[nextIndex].click();
    },
    true // capture phase ist entscheidend (Modal-Opener “schluckt” sonst den Klick)
  );
})();
